import CrudRoutes, {SimpleRoute} from "./_helpers/api";
import {createQueryParameters, getSiteUrl, to_url} from "./_helpers/utils";
import Booth from "./_data/models/Booth";
import {GeoState} from "./_definitions/styleteq";

export class UsersRoutes extends CrudRoutes {
    static root(): string {
        return 'users'
    }

    static short_url(str: string): string {
        return '/' + str;
    }

    static edit_profile(id: number): string {
        return to_url(getSiteUrl(), 'v1', 'users', id, 'edit');
    }

    static following(id: number | string = null): string {
        if (typeof id === 'number')
            return to_url(this.index(), id, 'following');
        else if (typeof id === 'string')
            return to_url(id, 'following');
    }

    static followers(id: number | string = null): string {
        if (typeof id === 'number')
            return to_url(this.index(), id, 'followers');
        else if (typeof id === 'string')
            return to_url(id, 'followers');
    }

    static sign_in(): string {
        return to_url(getSiteUrl(), 'v1', 'users', 'sign_in');
    }
}

export class ShopsRoutes extends CrudRoutes {
    static root(): string {
        return 'shops'
    }

    static view(id: number = -1): string {
        const _id = id == -1 ? ':shopId' : id;
        return to_url(this.index(), _id);
    }

    static viewBooth(shopId: number = -1, boothId: number = -1): string {
        const _id = boothId == -1 ? ':boothId' : boothId;

        return to_url(this.view(shopId), "booths", _id);
    }

    static addBooth(shopId: number = -1): string {
        return to_url(this.view(shopId), "add-booths");
    }

    static editBooth(booth: Booth): string {
        return to_url(this.index(), booth.shop.id, "booths", booth.id, "edit");
    }

}

export class StylesRoutes extends CrudRoutes {
    static root(): string {
        return 'styles'
    }

    static showStyle(username: string, styleId: number): string {
        return to_url(`/${username}`, 'styles', styleId);
    }
}

export class SpecialsRoutes extends CrudRoutes {
    static root(): string {
        return 'specials'
    }

    static view(id: number = -1): string {
        const _id = id == -1 ? ':id' : id;
        return to_url(this.index(), _id);
    }

    static tab(type: string = null): string {
        const _type = type == null ? ':type' : type;
        return to_url(this.index(), 'type', _type);
    }
}
export class BoothsRoutes extends CrudRoutes {
    static root(): string {
        return 'booths'
    }
}


export class FeedsRoutes extends SimpleRoute {
    static root(): string {
        return 'feeds'
    }

    static preview(id: number = -1): string {
        const _id = id == -1 ? ':id' : id;
        return this.index() + `?modal=true&feedId=${_id}`;
    }
}

export class SearchRoutes extends SimpleRoute {
    static root(): string {
        return 'search'
    }

    static query(q: string, geo: GeoState, typeFilter: string, secondaryFilters: string[], page: number, perPage: number = 25): string {
        return this.index() + this.queryUrl(q, geo, typeFilter, secondaryFilters, page, perPage);
    }

    static queryUrl(q: string, geo: GeoState, typeFilter: string, secondaryFilters: string[], page: number, perPage: number = 25): string {
        const query = createQueryParameters({
            q: q,
            'geo[address]': geo ? geo.address : null,
            'geo[latitude]': geo ? geo.latitude : null,
            'geo[longitude]': geo ? geo.longitude : null,
            resource: typeFilter,
            'filter': secondaryFilters,
            page: page,
            per_page: perPage
        });
        return query;
    }
}

export class ConversationsRoutes extends SimpleRoute {
    static root(): string {
        return 'inbox'
    }

    static messages(id: number): string {
        return to_url(this.index(), id, 'messages');
    }

    static new(id: number): string {
        return to_url(this.index(), 'new') + `?user_id=${id}`;
    }
}


// WEBPACK FOOTER //
// ./app/client/routes.ts